/* NeoSpherium · ns-shop.js · listing card engine for the shop-first home and the collection (Oct 2026, rebuild).
   One benchmarked mechanic: Alo's desktop quick add. A .ns-qa strip over the card photograph holds .ns-qa__size
   buttons (data-variant). A size click posts /cart/add.js with the cart drawer's sections and hands the result to
   cart-drawer.renderContents, which opens the drawer. Errors read inside the strip ([data-ns-qa-error]).
   The Alo color dots were removed on 12 Oct, and the strip now sits beside the card link, never inside it. */
(function () {
  'use strict';
  var I18N = window.NS_SHOP_I18N || {};

  function rootUrl() { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function srcsetFor(url) {
    if (typeof window.nsCardSrcset === 'function') return window.nsCardSrcset(url);
    var base = String(url).replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    var j = base.indexOf('?') < 0 ? '?' : '&';
    return [240, 360, 480, 600, 800, 1000, 1200].map(function (w) { return base + j + 'width=' + w + ' ' + w + 'w'; }).join(', ');
  }
  function syncCount() {
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.nav__cart-count:not([data-wish-count])').forEach(function (el) {
          el.textContent = c.item_count; el.hidden = c.item_count === 0;
        });
      }).catch(function () {});
  }
  function errorEl(card) { return card.querySelector('[data-ns-qa-error]'); }
  function showError(card, msg) { var e = errorEl(card); if (!e) return; e.textContent = msg; e.hidden = false; }
  function hideError(card) { var e = errorEl(card); if (e) e.hidden = true; }

  /* the quick add */
  function addSize(btn) {
    var card = btn.closest('.edit__cell'); if (!card) return;
    var strip = btn.closest('.ns-qa');
    var vid = btn.getAttribute('data-variant'); if (!vid) return;
    if (card.getAttribute('data-busy') === '1') return;
    card.setAttribute('data-busy', '1');
    if (strip) strip.classList.add('is-busy');
    btn.classList.add('is-adding'); btn.setAttribute('aria-busy', 'true');
    hideError(card);
    var d = drawer();
    var body = { items: [{ id: Number(vid), quantity: 1 }] };
    if (d && typeof d.getSectionsToRender === 'function') {
      body.sections = d.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    function settle() {
      card.removeAttribute('data-busy'); btn.classList.remove('is-adding'); btn.removeAttribute('aria-busy');
      if (strip) strip.classList.remove('is-busy');
    }
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (res) { return { ok: r.ok, res: res }; }); })
      .then(function (out) {
        if (!out.ok) {
          /* 422 (stock just ran out): keep the strip up and say so; silence would read as success */
          card.removeAttribute('data-busy'); btn.classList.remove('is-adding'); btn.removeAttribute('aria-busy');
          showError(card, out.res.description || out.res.message || I18N.stock || 'Not enough stock for this size.');
          return;
        }
        settle();
        if (d && typeof d.renderContents === 'function' && out.res.sections) {
          d.renderContents(out.res);
        } else {
          window.location.href = rootUrl() + 'cart';
          return;
        }
        setTimeout(syncCount, 400); setTimeout(syncCount, 1500);
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('ns_quick_add', { variant: vid, surface: (card.closest('[data-ns-shop], [data-cf-root]') || {}).id || 'listing' });
          }
        } catch (e) {}
      })
      .catch(function () { settle(); showError(card, I18N.error || 'Could not add this right now. Please try again.'); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var sz = t.closest('.ns-qa__size');
    if (sz) { e.preventDefault(); e.stopPropagation(); if (sz.disabled || sz.classList.contains('is-soldout')) return; addSize(sz); return; }
    if (t.closest('.ns-qa')) { e.preventDefault(); e.stopPropagation(); }   /* the strip's own ground never navigates */
  });
})();

/* 14 Oct 2026, Release 1: the home product rows swipe sideways (Alo captures 01 and 02 on the phone). On desktop a
   square arrow at each edge moves the row by the cards in view, and hides at the start or the end (Alo capture 99).
   The arrows sit at half the photograph's height. Reduced motion: the row jumps instead of gliding. */
(function () {
  'use strict';
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function init(row) {
    var track = row.querySelector('[data-ns-row-track]');
    var prev = row.querySelector('[data-ns-row-prev]');
    var next = row.querySelector('[data-ns-row-next]');
    if (!track || !prev || !next) return;
    var ticking = false;
    function cardStep() {
      var c = track.querySelector('.ns-card'); if (!c) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = c.getBoundingClientRect().width + gap;
      return w * Math.max(1, Math.round((track.clientWidth + gap) / w));
    }
    function sync() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.hidden = track.scrollLeft <= 2;
      next.hidden = track.scrollLeft >= max;
      var img = track.querySelector('.edit__img');
      if (img) row.style.setProperty('--nsrow-img', Math.round(img.getBoundingClientRect().height) + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(sync); } }
    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: cardStep(), behavior: reduce.matches ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    track.querySelectorAll('img').forEach(function (i) { if (!i.complete) i.addEventListener('load', onScroll, { once: true }); });
    sync();
  }
  function start() { document.querySelectorAll('[data-ns-row]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
